import {AfterContentChecked, Component, OnInit, ViewChild} from '@angular/core';
import {ckEditorConfiguration} from "../../../@admin/utils/constant/common.const";
import {CKEditorComponent, CKEditorModule} from "@ckeditor/ckeditor5-angular";
import {ActivatedRoute, ActivationEnd, Router} from "@angular/router";
import {DocumentationService} from "../../../api/services/documentation.service";
import {IPrams} from "../../../layout/layout.model";
import {Title} from "@angular/platform-browser";
import {NgDynamicBreadcrumbService} from "../../../@admin/components/breadcrumb/ng-dynamic-breadcrumb.service";
import {AppSidebarComponent} from "../../../layout/app.sidebar.component";
import {LeftMenuListResponse} from "../../../api/models/response/leftMenuListResponse";
import {findMenuFromMenuList} from "../../../@admin/utils/methods/common.function";
import CustomCkEditor from '../../../../../custom-ckeditor/build/ckeditor'
import {SharedService} from "../../../@admin/services/shared/shared.service";
import {NoRecordsFoundComponent} from "../../../@admin/components/no-records-found/no-records-found.component";
import {InternalDocumentationDetails} from "../../../api/models/response/internal-documentation-view-response";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-internal-documentations-view',
  standalone: true,
  imports: [
    CKEditorModule,
    NoRecordsFoundComponent,
    NgIf
  ],
  templateUrl: './internal-documentations-view.component.html',
  styleUrl: './internal-documentations-view.component.scss'
})
export class InternalDocumentationsViewComponent implements OnInit, AfterContentChecked {
  public internalDocs: InternalDocumentationDetails = {};
  public Editor = CustomCkEditor.Editor;
  ckEditorConfig: any = ckEditorConfiguration;
  @ViewChild(CKEditorComponent) ckEditor!: CKEditorComponent;
  private hasCalledApi: boolean = false; // Flag to prevent duplicate API calls
  constructor(private _activatedRoute: ActivatedRoute, private titleService: Title,
              private _docService: DocumentationService, private ngDynamicBreadcrumbService: NgDynamicBreadcrumbService, private _router: Router,
              public _docServiceHelper: SharedService) {
    this._router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        const params: IPrams = event.snapshot.params;
        if (params?.bookMarkUniqueId) {
          const menuDetails = findMenuFromMenuList(AppSidebarComponent.latestMenuList, params.bookMarkUniqueId);
          if (menuDetails) {
            this.getMenuDescByID(menuDetails, 1);
          }
        }
      }
    });
  }

  /**
   * lifecycle hook that runs once after the component is instantiated
   */
  ngOnInit(): void {
    this._activatedRoute.params.subscribe((params: IPrams) => {
      if (params.bookMarkUniqueId) {
        this.getData(params.bookMarkUniqueId);
      }
    });
    // Clear internalDocs on dropdown change
    this._docServiceHelper.triggerGetGuideGridDataList$.subscribe(() => {
      this.internalDocs = {};
    });
  }

  getData(bookMarkUniqueId: string | undefined): void {
    if (bookMarkUniqueId) {
      AppSidebarComponent.getMenuList.subscribe((menuList) => {
        const menuDetails = findMenuFromMenuList(menuList, bookMarkUniqueId)
        if (menuDetails) {
          this.getMenuDescByID(menuDetails, 3);
        }
      })
    }
  }

  getMenuDescByID(menu: LeftMenuListResponse, fromFun: number): void {
    if (fromFun === 1 || fromFun === 3 && !this.hasCalledApi) {
      this.hasCalledApi = true; // flag to prevent duplicate calls
      this._docService.GetInternalDocumentationByDocId(menu.id || 0).then(response => {
        if (response && response.data) {
          this.internalDocs = response.data;
          this.titleService.setTitle(`${this.internalDocs.mainTitle as string} | Internal Documentation`);
          this.ngDynamicBreadcrumbService.updateBreadcrumb([
            {
              label: `${this.internalDocs.mainTitle as string}`,
              url: ''
            }
          ]);
        }
      });
    }
  }

  ngAfterContentChecked(): void {
    const element = document.getElementById('classic-editor');
    if (element) {
      const toolbarEle = document.getElementsByClassName('ck ck-editor__top ck-reset_all');
      if (toolbarEle.length) {
        toolbarEle[0].remove();
      }
      const tableTopSelectionEle = document.getElementsByClassName('ck ck-widget__selection-handle');
      if (tableTopSelectionEle.length) {
        tableTopSelectionEle[0].remove();
      }
    }
  }
}
